var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.33325C10.8167 3.33325 3.33334 10.8166 3.33334 19.9999C3.33334 29.1833 10.8167 36.6666 20 36.6666C29.1833 36.6666 36.6667 29.1833 36.6667 19.9999C36.6667 10.8166 29.1833 3.33325 20 3.33325ZM27.9667 16.1666L18.5167 25.6166C18.2833 25.8499 17.9667 25.9833 17.6333 25.9833C17.3 25.9833 16.9833 25.8499 16.75 25.6166L12.0333 20.8999C11.55 20.4166 11.55 19.6166 12.0333 19.1333C12.5167 18.6499 13.3167 18.6499 13.8 19.1333L17.6333 22.9666L26.2 14.3999C26.6833 13.9166 27.4833 13.9166 27.9667 14.3999C28.45 14.8833 28.45 15.6666 27.9667 16.1666Z",
    fill: "#46DC94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.64520e8bd76938bf0f26669b55ff3758.svg";
export { ForwardRef as ReactComponent };